import { render, staticRenderFns } from "./TasksRenewal.vue?vue&type=template&id=896fa02c&scoped=true"
import script from "./TasksRenewal.vue?vue&type=script&lang=js"
export * from "./TasksRenewal.vue?vue&type=script&lang=js"
import style0 from "./TasksRenewal.vue?vue&type=style&index=0&id=896fa02c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896fa02c",
  null
  
)

export default component.exports